import api from "../config/api";
import { getErrorMessage } from "../config/errorHelper";

// ─────────────────────────────────────────────
//  COMPANIES
// ─────────────────────────────────────────────

/** Liste toutes les entreprises. */
export const getCompanies = async () => {
  try {
    const res = await api.get("/companies/all");
    return res.data;
  } catch (err) {
    throw new Error(getErrorMessage(err));
  }
};

/** Récupère une entreprise par son ID. */
export const getCompany = async (id) => {
  try {
    const res = await api.get(`/companies/${id}`);
    return res.data;
  } catch (err) {
    throw new Error(getErrorMessage(err));
  }
};

/**
 * Crée une nouvelle entreprise.
 * payload : { name, email, phone, address? }
 */
export const createCompany = async (payload) => {
  try {
    const res = await api.post("/companies/createCompany", payload);
    return res.data;
  } catch (err) {
    throw new Error(getErrorMessage(err));
  }
};

/**
 * Modifie une entreprise existante (patch partiel).
 * Inclut l'activation/désactivation via le champ `active`.
 */
export const updateCompany = async (id, payload) => {
  try {
    const res = await api.put(`/companies/${id}`, payload);
    return res.data;
  } catch (err) {
    throw new Error(getErrorMessage(err));
  }
};

/** Liste les utilisateurs rattachés à une entreprise. */
export const getCompanyUsers = async (id) => {
  try {
    const res = await api.get(`/companies/${id}/users`);
    return res.data;
  } catch (err) {
    throw new Error(getErrorMessage(err));
  }
};